import { render, staticRenderFns } from "./NoRisksAAIChart.vue?vue&type=template&id=aa8735a4&scoped=true"
import script from "./NoRisksAAIChart.vue?vue&type=script&lang=js"
export * from "./NoRisksAAIChart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa8735a4",
  null
  
)

export default component.exports